import type { App, Directive } from "vue";
import draggable from "./modules/draggable";
import debounce from "./modules/debounce";
import throttle from "./modules/throttle";
import highlight from "@/views/directives/modules/hightLight";

const directivesList: { [key: string]: Directive } = {
    draggable,
    debounce,
    throttle,
    highlight
};

const directives = {
    install: function (app: App<Element>) {
        Object.keys(directivesList).forEach(key => {
            app.directive(key, directivesList[key]);
        });
    }
};

export default directives;
